import "element-closest-polyfill";
import ResizeObserverPolyfill from "resize-observer-polyfill";
import isNaNPolyfill from "number.isnan";
import "./polyfills/promiseWithResolvers";

if (typeof window.ResizeObserver == "undefined")
  window.ResizeObserver = ResizeObserverPolyfill;
if (typeof Number.isNaN == "undefined") Number.isNaN = isNaNPolyfill;
